export enum AuthAction {
  SignIn = 'signIn',
  SignOut = 'signOut',
  UpdateAuthData = 'updateAuthData',
}
